import { Attachment } from "../../../";
import { Review, Tag, TagMatchType } from "../../../domain";
import { CandidateReviewSteps } from "./candidateReviewSteps";

export class CandidateReviewResult implements Review {
    timeZone: number;
    bestTimesToReach: TagMatchType[];
    additionalInformation: string;
    interviewAvailabilityNote: string;
    interviewingElsewhereNote: string;
    isInterviewingElsewhere: boolean;

    isUserPrimaryLocationWithinJobLocation: boolean;
    isWillingToRelocate: boolean;
    isRelocationAssistanceNeeded: boolean;
    noticeAvailability?: TagMatchType;
    isWillingToTravel: boolean;
    minSalary: number;
    maxSalary: number;
    salaryType: number;

    formattedResume: Attachment;

    sendSMSMessage?: boolean;
    sendEmail?: boolean;
    requiresVerification?: boolean;

    private constructor(steps: CandidateReviewSteps) {
        this.requiresVerification = steps.requiresVerification;
        this.additionalInformation = steps.stepThree.additionalInformation;

        this.noticeAvailability = Tag.fromId(steps.stepOne.noticeAvailability);
        this.timeZone = steps.stepOne.timeZone;
        this.interviewAvailabilityNote =
            steps.stepOne.interviewAvailabilityNote;
        this.interviewingElsewhereNote =
            steps.stepOne.interviewingElsewhereNote;
        this.isInterviewingElsewhere = steps.stepOne.isInterviewingElsewhere;

        this.formattedResume = steps.stepTwo.formattedResume;

        this.bestTimesToReach = steps.stepOne.bestTimesToReach.map(b => ({
            ...b,
        }));

        if (steps.stepFour.reviewRequiresVerification) {
            this.sendSMSMessage = steps.stepFour.sendSms;
            this.sendEmail = steps.stepFour.sendEmail;
        }
    }

    public static create = (
        steps: CandidateReviewSteps
    ): CandidateReviewResult => new CandidateReviewResult(steps);
}
